import styled from 'styled-components';
import {typographyStyle} from '@/components/Typography';
import {Flexbox, interceptProps} from '@/styled-components';
import {palette} from '@/styles';
import {withComma} from '@/utils';

export const CustomizedLegend = ({payload, marginTop = '0'}: any) => {
  return (
    <LegendWrapper marginTop={marginTop}>
      {payload.map((entry: any) => (
        <LegendItem key={`item-${entry.dataKey}`}>
          <LegendColor style={{backgroundColor: entry.color}} />
          {entry.value}
        </LegendItem>
      ))}
    </LegendWrapper>
  );
};

const LegendWrapper = styled(Flexbox).withConfig({
  shouldForwardProp: interceptProps(['marginTop']),
})<{marginTop?: string}>`
  gap: 12px;
  justify-content: center;
  margin-top: ${({marginTop}) => marginTop || '0'};
`;

const LegendItem = styled(Flexbox)`
  gap: 12px;
  color: ${palette.gray600};
  font-weight: 500;
  ${{...typographyStyle.medium12}}
`;

const LegendColor = styled.div`
  width: 8px;
  height: 8px;
`;

export const CustomizedTooltip = ({active, payload, customName}: any) => {
  if (active && payload && payload.length) {
    return (
      <TooltipWrapper>
        <TooltipLabel>{payload?.[0]?.payload?.name}</TooltipLabel>
        <TooltipItems>
          {payload.map((i: any) => (
            <TooltipItem style={{color: i.color}} key={`TooltipItem-${i.name}`}>
              {customName || i.name} : {withComma(i.value)}
            </TooltipItem>
          ))}
        </TooltipItems>
      </TooltipWrapper>
    );
  }

  return null;
};

const TooltipWrapper = styled.div`
  padding: 12px;
  border-radius: 3px;
  border: solid 1px ${palette.gray200};
  background-color: ${palette.white};
`;

const TooltipLabel = styled.div`
  color: ${palette.gray800};
  font-weight: 700;
  margin-bottom: 8px;
  ${{...typographyStyle.medium12}}
`;

const TooltipItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const TooltipItem = styled.div`
  color: ${palette.gray800};
  font-weight: 500;
  ${{...typographyStyle.medium12}}
`;

export const CustomTick = (props: any) => {
  const {x, y, payload} = props;

  const year = payload.value.substring(0, 4);
  const month = payload.value.substring(4, 6);

  return (
    <g transform={`translate(${x - 2},${y + 4})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="start"
        fontSize={12}
        fill={palette.gray600}
      >
        <tspan x="0" dy="0">
          {year}
        </tspan>
        <tspan x="0" dy="1.2em">{`.${month}`}</tspan>
      </text>
    </g>
  );
};
